import React from 'react'

import { useFlags } from 'shared/components/common/feature_flags/useFlags'
import { Trans } from 'src/translations'
import { useCart } from 'public/components/online_ordering/CartContext'
import { useCustomer } from 'src/public/components/online_ordering/CustomerContextCommon'
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay
} from 'src/shared/components/common/modal'
import { useModal } from 'src/shared/components/common/modal/useModal'

const MIN_ORDER_TOTAL = 30

const AskMapsDisclaimer = () => {
  const { cartReferrer, subtotal } = useCart()
  const { ooAskMapsCashEnabled } = useFlags()
  const { customer } = useCustomer()
  const { isOpen, onOpen, onClose } = useModal()

  if (!ooAskMapsCashEnabled || cartReferrer !== 'ask_maps') {
    return <hr className='separator' />
  }

  let disclaimerKey = 'checkout-mode-buttons.ask-maps-pay-warning'
  if (!customer && (subtotal ?? 0) < MIN_ORDER_TOTAL) {
    disclaimerKey = 'checkout-mode-buttons.ask-maps-all-warnings'
  } else if (!customer) {
    disclaimerKey = 'checkout-mode-buttons.ask-maps-account-warning'
  } else if ((subtotal ?? 0) < MIN_ORDER_TOTAL) {
    disclaimerKey = 'checkout-mode-buttons.ask-maps-subtotal-warning'
  }

  return (
    <>
      <div className='askMapsDisclaimer'>
        <div className='disclaimerText'>
          <Trans
            i18nKey={disclaimerKey}
            values={{ minOrderTotal: MIN_ORDER_TOTAL }}
            components={{
              button: <button type='button' onClick={onOpen} />
            }}
          />
        </div>
      </div>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay fadeIn fadeOut />
        <ModalContent contentClassName='modalContentV2 bottomDrawerMobile askMapsTermsModal'>
          <div className='header'>
            <ModalCloseButton />
          </div>
          <div className='body'>
            <Trans
              i18nKey='checkout-mode-buttons.ask-maps-terms-body'
              values={{ minOrderTotal: MIN_ORDER_TOTAL }}
              components={{
                b: <b />,
                a: (
                  <a
                    key='0'
                    href='https://pos.toasttab.com/terms-of-service'
                    rel='noopener noreferrer'
                    target='_blank'
                  />
                )
              }}
            />
          </div>
        </ModalContent>
      </Modal>
    </>
  )
}

export default AskMapsDisclaimer
